import { makeStyles } from '@material-ui/core/styles';
import zIndex from '@material-ui/core/styles/zIndex';
import { ForkRight, RiceBowl } from '@mui/icons-material';

export const useStyles = makeStyles(theme => ({
  main: {
    marginTop: '-65px',
    margin: '0 -2.5rem',
    padding: '0 2.5rem',
    backgroundColor: '#101012',
    '@media (max-width: 960px)': {
      marginTop: '0',
    },
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
    backgroundColor: '#101012',
    color: '#fff',
    '@media (max-width: 960px)': {
      height: '88.9vh',
    },
    '@media (max-width: 600px)': {
      height: '92.33vh',
    },
    //overflow: 'hidden', // Prevent scrolling
  },
  warning: {
    color: '#c1c3c7',
    margin: '0px',
  },
  headerContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    marginTop: '0.625rem', // 10px
    width: '100%',
    height: '0',
    zIndex: '0',
    boxSizing: 'border-box', // Ensure padding is included in width
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
  },
  headerRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    boxSizing: 'border-box',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'row',
      alignItems: 'flex-start',
    },
  },
  headerButtons: {
    width: 'auto',
    display: 'flex',
    whiteSpace: 'nowrap',
    gap: '1.25rem', // 20px
    marginLeft: 'auto', // Pushes this element to the right
    justifyContent: 'flex-end',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  backButton: {
    color: '#fff',
    backgroundColor: '#101012',
    border: 'none',
    borderRadius: '0.5rem', // 8px
    padding: '0.625rem 1.25rem', // 10px 20px
    cursor: 'pointer',
    fontFamily: 'Pretendard',
    fontWeight: '700',
    fontSize: 'auto', // 18px
    lineHeight: '1.5rem', // 24px
    textAlign: 'center',
    whiteSpace: 'nowrap',
    '@media (max-width: 600px)': {
      padding: '0.5rem 1rem', // 10px 20px
      fontSize: '0.75rem', // 12px
      lineHeight: '1rem', // 16px
    },
  },
  disabledButton: {
    opacity: '0.5',
    cursor: 'not-allowed',
  },
  deleteButton: {
    color: '#fff',
    backgroundColor: '#2d2e2f',
    border: 'none',
    borderRadius: '0.5rem', // 8px
    padding: '0.375rem 1rem', // 6px 16px
    cursor: 'pointer',
    fontFamily: 'Pretendard',
    fontWeight: '700',
    fontSize: '0.875rem', // 14px
    lineHeight: '1.25rem', // 20px
    '@media (max-width: 600px)': {
      padding: '0.3rem 0.8rem', // 6px 12px
      fontSize: '0.75rem', // 12px
      lineHeight: '1rem', // 16px
      marginRight: '0.5rem', // 8px
    },
  },
  newChatButton: {
    color: '#1c1c1c',
    backgroundColor: '#ffffff',
    border: 'none',
    borderRadius: '0.5rem', // 8px
    padding: '0.75rem 1.25rem 0.75rem 0.875rem', // 12px 20px 12px 14px
    cursor: 'pointer',
    fontFamily: 'Pretendard',
    fontWeight: '700',
    fontSize: '0.875rem', // 14px
    lineHeight: '1.25rem', // 20px
    '@media (max-width: 600px)': {
      padding: '0.5rem 0.6rem 0.5rem 0.6rem', // 12px 12px 12px 12px
      fontSize: '0.75rem', // 12px
      lineHeight: '1rem', // 16px
    },
  },
  profileContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: '2rem',
    marginBottom: '0.5rem', // 20px
    '@media (max-width: 600px)': {
      marginTop: '3rem', // 20px
    },
  },
  header: {
    textAlign: 'center',
    color: '#fff',
    marginTop: '0.625rem', // 10px
  },
  image: {
    width: '4rem', // 80px
    height: '4rem', // 80px
    borderRadius: '50%',
  },
  chatContainer: {
    // marginTop: '0.3rem',
    flex: 1,
    overflowY: 'auto',
    padding: '0.625rem', // 10px
    borderRadius: '0.5rem', // 8px
    height: '57vh',
    /* 스크롤바 숨기기 */
    '&::-webkit-scrollbar': {
      display: 'none', // for Chrome, Safari, and Opera
    },
    '-ms-overflow-style': 'none', // for Internet Explorer and Edge
    'scrollbar-width': 'none', // for Firefox
    '@media (max-width: 960px)': {
      height: '50vh',
    },
  },
  inputContainer: {
    display: 'flex',
    alignItems: 'center',
    // position: 'relative',
    position: 'sticky',
    bottom: 0,
    padding: '0.625rem', // 10px
    zIndex: 10,
    backgroundColor: '#101012',
  },

  sendContainer: {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    width: '100%',
  },

  input: {
    width: '100%',
    fontFamily: 'TheJamsil, sans-serif',
    minHeight: '2rem', // 초기 높이를 텍스트 한 줄 크기에 맞게 설정
    padding: '1.1rem 3rem 1.1rem 1.25rem', // 패딩을 조정하여 원하는 디자인 구현
    borderRadius: '4rem',
    border: '1px solid #555',
    backgroundColor: '#2d2e2f',
    color: '#fff',
    outline: 'none',
    height: '48px',
    fontSize: '0.8rem',
    lineHeight: '1', // 줄 간격을 최소로 설정
    resize: 'none', // 사용자가 크기를 조정할 수 없도록 설정
    overflowY: 'hidden', // 스크롤이 나타나지 않도록 설정
    boxSizing: 'border-box',
    textAlign: 'left', // 텍스트를 왼쪽 정렬로 설정
    verticalAlign: 'middle', // 텍스트가 중앙에 위치하도록 설정
    '@media (max-width: 600px)': {
      padding: '0.88rem 2rem 0.88rem 1rem',
      height: '41px',
      fontSize: '0.8rem',
    },
  },

  sendButton: {
    display: 'flex',
    position: 'absolute', // 절대 위치로 설정하여 input 안에 배치
    right: '1.7%', // input 내부에서 오른쪽에 배치
    width: '1.7rem', // 버튼의 너비를 고정
    height: '1.7rem', // 버튼의 높이를 고정
    borderRadius: '50%', // 원 모양으로 만들기 위해 반지름 설정
    border: 'none',
    backgroundColor: '#1c1c1c',
    color: '#fff',
    cursor: 'pointer',
    alignItems: 'center',
    justifyContent: 'center', // 아이콘을 가운데 정렬
    fontSize: '1rem',
    '&.disabled': {
      backgroundColor: '#6c757d',
      cursor: 'not-allowed',
    },
    '@media (max-width: 600px)': {
      right: '5%',
    },
  },

  sttButton: {
    marginLeft: '0.625rem', // 10px
    padding: '0.625rem 1.25rem', // 10px 20px
    borderRadius: '0.25rem', // 4px
    border: 'none',
    backgroundColor: '#28a745',
    color: '#fff',
    cursor: 'pointer',
    '&.recording': {
      backgroundColor: '#D24146',
      cursor: 'pointer',
    },
    '&.disabled': {
      backgroundColor: '#6c757d',
      cursor: 'not-allowed',
    },
  },
  voiceIcon: {
    width: '1.5rem', // 24px
    height: '1.5rem', // 24px
    color: '#fff',
  },
  bars: {
    display: 'flex',
    alignItems: 'flex-end',
    position: 'absolute', // 절대 위치로 설정하여 input 안에 배치
    right: '6%', // 10px
    justifyContent: 'center',
    width: '1.5rem', // 24px
    height: '1.5rem', // 24px
    '@media (max-width: 600px)': {
      right: '3rem', // 10px
    },
    '@media (min-width 600px and max-width: 960px)': {
      right: '9%', // 10px
    },
  },
  bar: {
    width: '0.1875rem', // 3px
    height: '50%',
    margin: '0 0.0625rem', // 0 1px
    transformOrigin: 'bottom',
    backgroundColor: '#00FF00',
    animation: '$bar 1s infinite ease-in-out',
    '&:nth-child(2)': {
      animationDelay: '0.1s',
    },
    '&:nth-child(3)': {
      animationDelay: '0.2s',
    },
  },
  '@keyframes bar': {
    '0%, 100%': {
      transform: 'scaleY(0.1)',
    },
    '50%': {
      transform: 'scaleY(1)',
    },
  },
}));
